import { useContext, useEffect } from 'react';
import { TrayContext, TrayState } from './TrayProvider';

export function useTray(id: string, defaults: TrayState) {
  const { map, dispatch } = useContext(TrayContext);

  useEffect(() => {
    dispatch({ type: 'INIT', id, state: defaults });
  // Only run on mount — defaults are the initial values and don't change
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const state = map[id] ?? defaults;

  return {
    isOpen: state.isOpen,
    width: state.width,
    setOpen: (isOpen: boolean) => dispatch({ type: 'SET_OPEN', id, isOpen }),
    setWidth: (width: number) => dispatch({ type: 'SET_WIDTH', id, width }),
  };
}
